module.exports = __webpack_public_path__ + "models/scene2.f0de3e3.atlas";